const faqs = [
  {
    q: '皮皮漫画是否完全免费？',
    a: '是的，皮皮漫画所有漫画内容均为完全免费阅读。我们通过广告赞助模式支撑平台服务器和带宽成本，不会向读者收取任何费用。无论是皮皮漫画韩漫、日漫还是国漫，都无需付费订阅即可畅读。',
  },
  {
    q: '皮皮漫画支持哪些设备阅读？',
    a: '皮皮漫画支持手机（iOS/Android）、平板和电脑（Web端）多设备阅读。推荐下载皮皮漫画APP获得更流畅的翻页体验，支持离线缓存、夜间模式和自动翻页等实用功能。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '热门连载漫画通常每周更新一话，具体更新频率取决于原作连载进度和汉化组工作效率。皮皮漫画韩漫频道的大部分作品会在韩国更新后24小时内同步上线，日漫和国漫也会在第一时间更新。你可以在「更新动态」模块查看最新上架列表。',
  },
  {
    q: '如何找到我喜欢的漫画类型？',
    a: '皮皮漫画提供完善的类型筛选功能：在「类型大全」模块可以按恋爱、热血、奇幻、悬疑、都市、武侠、科幻等分类浏览；也可以通过「热门话题」模块查看当前读者关注的热门标签；首页「精选推荐」和「人气排行」模块展示了编辑推荐和读者评分最高的作品。',
  },
  {
    q: '皮皮漫画的漫画是正版吗？',
    a: '皮皮漫画与多家国内外出版社及版权方建立了正式合作关系，平台上的漫画内容均已获得正版授权。我们尊重知识产权，致力于为读者提供合法、安全的阅读环境。如有版权问题，欢迎通过「联系我们」模块与我们沟通。',
  },
  {
    q: '如何向皮皮漫画投稿或建议？',
    a: '原创漫画作者和汉化组可以通过「联系我们」模块中的「作者投稿」渠道与我们联系，发送作品至 author@pipicomic.com。功能建议和问题反馈请发送至 support@pipicomic.com，我们会在48小时内回复。皮皮漫画欢迎每一位漫画爱好者的参与和支持。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            关于皮皮漫画使用的常见疑问与解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 flex items-start gap-3">
                  <span className="text-primary-500 shrink-0 mt-0.5">Q</span>
                  <span>{faq.q}</span>
                </h3>
                <div className="mt-3 flex items-start gap-3">
                  <span className="text-accent-500 shrink-0 mt-0.5 text-sm font-heading">A</span>
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}